import React from 'react';
import Sidebar from '../components/Sidebar';
import InformeConsumoPanel from '../components/InformeConsumoPanel';

function GenerarPlanillaConsumo() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />

      <main className="flex-1 overflow-y-auto">
        <div className="p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-[#111618]">Planilla de Consumo</h1>
            <p className="text-[#617c89] mt-2">
              Acceso directo para generar la planilla de consumo por zona y período.
            </p>
          </div>

          <InformeConsumoPanel />
        </div>
      </main>
    </div>
  );
}

export default GenerarPlanillaConsumo;
